import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/help/")({
  beforeLoad: () => {
    // 301 permanent redirect to new docs location
    throw redirect({
      to: "/docs/$lang",
      params: { lang: "en" },
      replace: true,
    })
  },
})
